import React from 'react'
import styled from 'styled-components'

import about_our_leads from "../../../../images/agent-training-center_about_our_leads.png"
import about_referral_manager from "../../../../images/agent-training-center_about_referral_manager.png"
import navigating_common_challenges from "../../../../images/agent-training-center_navigating_common_challenges.png"
import tips_for_success from "../../../../images/agent-training-center_tips_for_success.png"

const getImageFromSlug = (slug) => {
  switch(slug) {
    case 'about_our_leads':
      return about_our_leads
    case 'about_referral_manager':
      return about_referral_manager
    case 'navigating_common_challenges':
      return navigating_common_challenges
    case 'tips_for_success':
      return tips_for_success
    default:
      return ''
  }
}

const TrainingCardContainer = styled.div`
height: 200px;
min-width: 400px;
max-width: 600px;
flex: 1 1 40%;
margin: 24px 2.5%;
padding: 50px;
border-radius: 2px;
box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.1);
flex-direction: row;
justify-content: space-between;
align-items: center;
cursor: pointer;
`

const TrainingCardItem = styled.div`
display: flex;
flex-direction: 'row';
height: 100%;
`

const TrainingCardImage = styled.div`
height: 100px;
width: 100px;
background-size: contain;
background-repeat: no-repeat;
display: inline-flex;
${props => props.slug ?
  `background-image: url(${getImageFromSlug(props.slug)});` :
  ''
}
`

const TrainingCardText = styled.div`
display: flex;
flex-direction: column;
align-self: center;
padding-left: 40px;
`

const TrainingCardTitle = styled.div`
font-family: "Circular", sans-serif;
font-size: 24px;
color: #4a4a4a;
`

const TrainingCardSummary = styled.div`
padding-top: 14px;
font-family: "Circular", sans-serif;
font-size: 20px;
color: #8c8c8c;
`

export const TrainingCard = ({ title, summary, slug, onClick }) => (
  <TrainingCardContainer onClick={onClick}>
    <TrainingCardItem>
      <TrainingCardImage slug={slug}/>
      <TrainingCardText>
        <TrainingCardTitle>{title}</TrainingCardTitle>
        <TrainingCardSummary>{summary}</TrainingCardSummary>
      </TrainingCardText>
    </TrainingCardItem>
  </TrainingCardContainer>
)
